var _ = require('underscore');
var Section = require('front/pages/Section/Section');

require('./Contact.less');

var CommonMap = require('front/components/CommonMap/CommonMap');

module.exports = Section.extend({

    el: '.Contact',

    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'CommonMap': {selector: '.CommonMap', viewConstructor: CommonMap}
    },


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'scrollToRegionFromUrl');

        Section.prototype.initialize.call(this, options);
    },

    activate: function () {
        this.scrollToRegionFromUrl();

        $(window).on('hashchange', this.scrollToRegionFromUrl);

        return Section.prototype.activate.call(this);
    },


    deactivate: function (params) {
        $(window).off('hashchange', this.scrollToRegionFromUrl);

        return Section.prototype.deactivate.call(this, params);
    },


    scrollToRegionFromUrl: function (e) {
        var hash = location.hash.slice(1);
        var $list = this.$('.Contact-region[data-id="' + hash + '"]');

        if (!hash) return;

        if (!$list.length) {
            app.animateWindowScroll(0);
        } else {
            if (e) {
                app.animateWindowScroll($list.offset().top - 70);
            } else {
                setTimeout(function () {
                    app.animateWindowScroll($list.offset().top - 70);
                }, app.settings.isDesktop ? 300 : 700);
            }
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/Contact/Contact.js
// module id = 265
// module chunks = 0